import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { getSweepWaveform, getComponentInfo } from '@/services/Sierra/results';
import NP from 'number-precision';
import { SweepResultData } from '@/services/Sierra';
import { PINTOPINSIM_RAW_FAST, PINTOPINSIM_RAW_HIRE } from '../../constants';
import defaultColor from '@/constants/defaultColors';
import { strDelimited } from '@/services/helper/split';
import { getDataList } from '@/services/Sierra/helper/WaveformResultHelper';
import WaveForm from '../components/WaveForm';
import { getWaveFormJsonConfig, getWaveFormPostProcessEdgesInfo, PPROC_VERSION, updateSpecInPPROCConfig } from '../../../../services/Sierra/results';
import { judgePostProcessSignalType } from '../../../../services/Sierra/helper/WaveformResultHelper';
import { recalcMeasure, updateSweepReCalc } from '../../store/result/action';
import { updateProgress } from '../../store/simulation/action';
import { WAVEFORM } from '../../../../services/Result/Public/resultConstants';
import resultOperation from '../../../../services/Result/Public/resultOperation';
import { updateLibraryTree } from '../../store/library/action';

NP.enableBoundaryChecking(false);
class WaveformSweep extends Component {
  constructor(props) {
    super(props);
    this.svgRef = createRef();
    this.contentRef = createRef();
    const { expVerificationId } = props;
    const resultOpera = resultOperation.getOperationByKey(expVerificationId, WAVEFORM) || {};
    this.state = {
      loading: true,
      compInfo: [],
      currentSignals: null,
      displayMode: 'Hi-Re',
      resultList: [],
      dataList: { Waveform: { list: [], show: [] } },
      portSelect: {},
      allDesigns: [],
      isPostProcess: false,
      allSweepReCalc: [],
      sweepTimeShowList: [],
      resultOpera: resultOpera || {},
      expandedKeys: []
    }
  }

  onRef = (ref) => {
    this.waveformSetting = ref;
  }

  componentDidMount = () => {
    /*  this.screenChange(); */
    const { currentProjectId, sweepId } = this.props;
    if (currentProjectId && sweepId) {
      this.getInitData()
    }
  }

  getInitData = async () => {
    const { expVerificationId } = this.props;
    if (!resultOperation.getOperation(expVerificationId) && expVerificationId) {
      await resultOperation.getSettings(expVerificationId)
    }
    const resultOpera = resultOperation.getOperationByKey(expVerificationId, WAVEFORM) || {};
    this.setState({
      resultOpera,
      resultList: []
    }, () => {
      this.getData(true)
    })
  }

  componentDidUpdate = async (prevProps) => {
    const { sweepListStatus, sweepReCalc, expKeyStatus } = this.props;
    if (sweepListStatus && sweepListStatus !== prevProps.sweepListStatus) {
      this.setState({
        displayMode: 'Hi-Re'
      })
      this.getInitData();
      this.props.updateSweepListStatus(false)
    } else if (expKeyStatus && expKeyStatus !== prevProps.expKeyStatus) {
      this.props.updateExpKeyStatus(false)
      this.setState({
        resultList: []
      }, () => {
        this.getData(false, true)
      })
    }

    if (prevProps.sweepReCalc && prevProps.sweepReCalc.length
      && (!sweepReCalc || !sweepReCalc.length)) {
      this.reGetPostProcessResult()
    }
  }

  getData = (isFirst, keep) => {
    const { resultList } = this.props;
    this.setState({
      resultList: JSON.parse(JSON.stringify(resultList))
    }, () => {
      this.getJson(isFirst, keep);
    })
  }

  getJson = async (isFirst, keep) => {
    const { currentProjectId } = this.props;
    const { resultList } = this.state;
    const newResultList = [], signals = [];
    let allDesigns = [];
    for (let exp of resultList) {
      const res = await SweepResultData.getVerificationJsonPromise(exp.id, currentProjectId);
      if (res) {
        const designs = []
        let currentInterfaces = SweepResultData.getInterfaces(exp.id);
        currentInterfaces.forEach(item => {
          designs.push({
            id: item.pcbId,
            name: item.pcb
          });
        });

        let currentInterfaceInfo = SweepResultData.getInfo(exp.id);
        if (currentInterfaceInfo && currentInterfaceInfo.signals) {
          signals.push(...currentInterfaceInfo.signals.map(item => ({ name: `${item.name}` })));
        }
        newResultList.push({ ...exp, currentInterfaceInfo, designs });
        allDesigns = [...new Set([...allDesigns, ...designs.map(item => item.name)])]
      }
    }
    this.setState({
      resultList: newResultList,
      currentSignals: { signals },
      allDesigns: allDesigns.map((name, index) => ({ name, color: defaultColor[index + 1] }))
    }, () => {
      this.getWaveform(isFirst, keep);
    })
  }

  /*   componentWillUnmount() {
      window.removeEventListener('resize', this.resize);
    }
  
    screenChange() {
      window.addEventListener('resize', this.resize);
    }
  
    resize = () => {
      if (this.waveform) {
        this.waveform.plot.redrawPlot(this.svgRef.current);
      }
    } */

  updateState = (key, value) => {
    this.setState({ [key]: value });
  }

  getWaveform = async (isFirst, keep) => {
    this.setState({
      loading: true
    }, async () => {
      const { displayMode, resultList, resultOpera = {} } = this.state;
      let _displayMode = displayMode;
      let sweepTimeShowList = []
      const { displayMode: displayModeOpera, portSelect: _portSelect } = resultOpera;
      if (isFirst) {
        _displayMode = displayModeOpera || _displayMode;
      }
      const option = _displayMode === 'Hi-Re' ? PINTOPINSIM_RAW_HIRE : PINTOPINSIM_RAW_FAST;
      this.setState({
        displayMode: _displayMode
      })
      const events = {
        changeMouse: this.childComp.changeMouse,
        cancelMove: this.childComp.cancelMove,
        changeAxis: this.childComp.changeAxis,
      }
      let compInfo = [], waveform = null;

      let isPostProcess = false, isNewPPROCObj = {};

      for (let item of resultList) {
        const _waveform = await getSweepWaveform(item.id, option, keep);
        _waveform.plotWaveform({ svgElement: this.svgRef.current, events });
        let { postProcessDataList = {}, postProcessConfig = null, isPostProcess: itemIsPostProcess, isNewPPROC } = await this.getPostProcessResult(item.verificationId);
        if (itemIsPostProcess) {
          isPostProcess = true;
         // sweepTimeShowList.push(item.name)
        }
        isNewPPROCObj[item.id] = isNewPPROC;
        const curves = _waveform.getCurves();
        let _compInfo = getComponentInfo(item.currentInterfaceInfo, curves, item.designs);
        const compInfoLength = compInfo.length;
        _compInfo = _compInfo.map((c, index) => ({
          ...c,
          curveName: `${c.curveName}_${item.id}`,
          curveIndex: index + compInfoLength,
          experiment: item.name,
          postProcessData: postProcessDataList && postProcessDataList[c.curveName] ? { ...postProcessDataList[c.curveName], id: c.curveName, verificationId: item.verificationId } : {},
          postProcessConfig
        }));
        compInfo.push(..._compInfo);
        if (waveform) {
          waveform.curveData = [...waveform.curveData, ..._waveform.curveData];
          waveform.signals = [...waveform.signals, ..._waveform.signals.map(signal => ({ ...signal, name: `${signal.name}_${item.id}` }))]
          waveform.plot && waveform.plot.curves.push(..._waveform.plot.curves.map((cu, index) => ({
            ...cu,
            name: `${cu.name}_${item.id}`,
            /*  color: defaultColor[(index + compInfoLength) % defaultColor.length] */
          })))
        } else {
          _waveform.signals = _waveform.signals.map(signal => ({ ...signal, name: `${signal.name}_${item.id}` }));
          _waveform.plot.curves = [..._waveform.plot.curves.map((cu, index) => ({
            ...cu,
            name: `${cu.name}_${item.id}`
          }))]
          waveform = _waveform;
        }
      }
      if (compInfo.length && waveform) {
        waveform.plotWaveform({ svgElement: this.svgRef.current, events });
        this.waveform = waveform;
        compInfo = compInfo.map((ci, index) => {
          const color = defaultColor[index % defaultColor.length];
          const curveIndex = waveform.plot.curves.findIndex(item => item.name === ci.curveName);
          if (curveIndex > -1) {
            waveform.plot.curves[curveIndex].color = color;
          }
          return { ...ci, color }
        });
        let { _compInfo, dataList, portSelect, allPortSelect, compPinGroupObj } = getDataList(compInfo);
        portSelect = keep ? this.state.portSelect : _portSelect && Object.keys(_portSelect).length ? _portSelect : portSelect;
        this.setState({
          loading: false,
          compInfo: _compInfo,
          dataList,
          portSelect,
          allPortSelect,
          isPostProcess,
          sweepTimeShowList,
          isNewPPROCObj,
          compPinGroupObj,
          expandedKeys: ["Result", ...Object.keys(allPortSelect || {})]
        }, () => {
          this.getCurves()
          setTimeout(() => {
            this.childComp.setDefaultProcessData()
          }, 500)
        });
      }
    })
  }

  getPostProcessResult = async (verificationId) => {
    let postProcessDataList = {}, postProcessConfig = null, isPostProcess = false, isNewPPROC = false;
    try {
      postProcessDataList = await getWaveFormPostProcessEdgesInfo(verificationId)
      isPostProcess = true
    } catch (error) {
      console.error("Get edges file error: ", error);
    }
    try {
      postProcessConfig = await getWaveFormJsonConfig(verificationId);
      //update gpio spec by library
      postProcessConfig = await updateSpecInPPROCConfig(postProcessConfig);
    } catch (error) {
      console.error("Get pproc-config file error: ", error);
    }
    if (postProcessConfig) {
      postProcessDataList = judgePostProcessSignalType(postProcessDataList, postProcessConfig);
      isNewPPROC = postProcessConfig.version === PPROC_VERSION;
    }
    return { postProcessDataList, postProcessConfig, isPostProcess, isNewPPROC }
  }

  reGetPostProcessResult = async () => {
    const { allSweepReCalc } = this.state;
    if (!allSweepReCalc) {
      return;
    }

    const { compInfo, isPostProcess } = this.state;
    let _compInfo = [...compInfo], pprocConfigInfo = {}, _isPostProcess = isPostProcess, isNewPPROCObj = {};
    for (let item of allSweepReCalc) {
      let { postProcessDataList = {}, postProcessConfig = null, isPostProcess: itemIsPostProcess, isNewPPROC } = await this.getPostProcessResult(item.verificationId);
      pprocConfigInfo[item.id] = {
        postProcessDataList,
        postProcessConfig,
        verificationId: item.verificationId,
        isNewPPROC
      }
      isNewPPROCObj[item.id] = isNewPPROC;
      if (itemIsPostProcess) {
        _isPostProcess = itemIsPostProcess
      }
    }

    for (let info of _compInfo) {
      const curveNames = info.curveName.split("_");
      const id = curveNames[curveNames.length - 1];
      if (!pprocConfigInfo[id]) {
        continue;
      }
      const curveName = curveNames.filter((it, index) => index < curveNames.length - 1).join("_");
      info.postProcessConfig = pprocConfigInfo[id].postProcessConfig || {};
      const currData = pprocConfigInfo[id].postProcessDataList && pprocConfigInfo[id].postProcessDataList[curveName] ? { ...pprocConfigInfo[id].postProcessDataList[curveName], id: curveName } : {};
      const newPostProcessData = {
        ...currData,
        curveName: info.postProcessData.curveName,
        title: info.postProcessData.title,
        signal: info.postProcessData.signal,
        displayTitle: info.postProcessData.displayTitle,
        verificationId: pprocConfigInfo[id].verificationId
      }
      info.postProcessData = newPostProcessData;
    }
    this.setState({
      compInfo: _compInfo,
      allSweepReCalc: null,
      isPostProcess: _isPostProcess,
      isNewPPROCObj
    })
  }

  displayModeChange = (e) => {
    this.setState({ displayMode: e.target.value }, () => {
      this.getWaveform();
      try {
        for (let item of this.state.resultList || []) {
          if (!item.verificationId) {
            continue;
          }
          this.setResultOpera({ displayMode: e.target.value })
        }
      } catch (error) {
        console.error(error);
      }
    });
  }

  colorChange = (e, key, indexs) => {
    const value = e.toHexString()
    if (value) {
      const { compInfo } = this.state;
      const [experiment] = strDelimited(key, '@');
      const curveIndex = indexs[experiment];
      const curves = this.waveform.getCurves();
      if (curveIndex > -1) {
        compInfo[curveIndex].color = value;
        curves[curveIndex].color = value;
        const { _compInfo, dataList } = getDataList(compInfo);
        this.waveform.updataRawCurvePlot();
        this.setState({
          compInfo: _compInfo,
          dataList,
        })
      }
    }
  }

  getPortSelect = (data, signalPortSelect = [], allChecked) => {
    let _signalPortSelect = [...signalPortSelect]
    const { selectPortData, allPortData } = data
    if (allChecked) {
      _signalPortSelect = _signalPortSelect.filter(item => !selectPortData.includes(item));
    } else {
      const idList = allPortData.filter(item => !selectPortData.includes(item))
      if (_signalPortSelect) {
        _signalPortSelect.push(...idList)
      } else {
        _signalPortSelect = [...idList]
      }
    }
    return _signalPortSelect
  }

  changeSelectAll = (e, type, expName, signal) => {
    let { portSelect, allPortSelect } = this.state;
    const checked = e.target.checked;
    if (type === "exp") {
      for (let key in allPortSelect) {
        const rowKeys = allPortSelect[key].filter(item => strDelimited(item, '@')[0] === expName);
        portSelect[key] = checked ? [...new Set([...(portSelect[key] || []), ...rowKeys])] : (portSelect[key] || []).filter(item => !rowKeys.includes(item));
      }
    }

    if (type === "signal") {
      const rowKeys = (allPortSelect[signal] || []).filter(item => strDelimited(item, '@')[0] === expName);
      portSelect[signal] = checked ? [...new Set([...(portSelect[signal] || []), ...rowKeys])] : (portSelect[signal] || []).filter(item => !rowKeys.includes(item));
    }

    this.setState({
      portSelect: portSelect
    }, () => {
      this.setResultOpera({ portSelect })
      this.getCurves()
    })
  }

  changePort = (value, key, fileId) => {
    const { portSelect } = this.state;
    if (!key) {
      return;
    }
    portSelect[key] = value;
    this.setState({ portSelect }, () => { this.setResultOpera({ portSelect }); this.getCurves() })
  }

  changeSinglePort = (e, row, portId) => {
    const { portSelect } = this.state;
    if (!row || !portId) {
      return;
    }
    const checked = e.target.checked;
    portSelect[row] = checked ? [...new Set([...(portSelect[row] || []), portId])] : (portSelect[row] || []).filter(item => item !== portId);
    this.setState({ portSelect }, () => { this.setResultOpera({ portSelect }); this.getCurves() })
  }

  getSweepChecked = (expName, signal) => {
    const { portSelect, allPortSelect } = this.state;
    if (!allPortSelect || !portSelect || !Object.keys(allPortSelect).length || !Object.keys(portSelect).length) {
      return {
        checked: false,
        indeterminate: false
      }
    }
    if (signal) {
      const allKeys = (allPortSelect[signal] || []).filter(item => strDelimited(item, '@')[0] === expName);
      const checked = allKeys.every(item => (portSelect[signal] || []).includes(item));
      return {
        checked,
        indeterminate: !checked && allKeys.some(item => (portSelect[signal] || []).includes(item))
      }
    } else {
      const allKeys = Object.keys(allPortSelect).map(item => allPortSelect[item].filter(name => strDelimited(name, '@')[0] === expName)).flat(2);
      const selectedKeys = Object.keys(portSelect).map(item => portSelect[item]).flat(2);
      const checked = allKeys.every(item => selectedKeys.includes(item));
      return {
        checked,
        indeterminate: !checked && allKeys.some(item => selectedKeys.includes(item))
      }
    }
  }


  changeTreeCheckedKeys = ({ checked, nodeData }) => {

    const { allPortSelect, portSelect, compPinGroupObj } = this.state;
    if (nodeData.children) {
      //row Name
      const values = checked ? allPortSelect[nodeData.id] || [] : [];
      portSelect[nodeData.key] = values;
      this.setState({ portSelect }, () => { this.setResultOpera({ portSelect }); this.getCurves() })
    } else {
      // component - pin
      const portKey = strDelimited(nodeData.id, "@")[1];
      const allKeys = compPinGroupObj[portKey].map(item => `${item}@${portKey}`);
      if (!portSelect[nodeData.parentKey]) {
        portSelect[nodeData.parentKey] = []
      }
      portSelect[nodeData.parentKey] = checked
        ? [...new Set([...portSelect[nodeData.parentKey], ...allKeys])]
        : portSelect[nodeData.parentKey].filter(item => !allKeys.includes(item));

      this.setState({ portSelect }, () => { this.setResultOpera({ portSelect }); this.getCurves() })
    }
  }

  getTreeCheckedKeys = () => {
    const { allPortSelect, portSelect, compPinGroupObj } = this.state;
    if (!allPortSelect || !portSelect || !Object.keys(allPortSelect).length || !Object.keys(portSelect).length) {
      return { checked: [], halfChecked: [] }

    }
    let checked = [], halfChecked = [];
    //comp pin checked
    const selectedKeys = Object.keys(portSelect).map(item => portSelect[item]).flat(2);
    for (let key in compPinGroupObj) {
      const exps = compPinGroupObj[key];
      const currKeys = exps.map(item => { return `${item}@${key}` });
      const isAllChecked = currKeys.every(item => selectedKeys.includes(item));
      if (isAllChecked) {
        checked.push(currKeys[0]);
      } else if (currKeys.some(item => selectedKeys.includes(item))) {
        halfChecked.push(currKeys[0]);
      }
    }

    //signal checked 
    let signalChecked = [], signalHalfChecked = [];
    for (let key in allPortSelect) {
      const allChecked = allPortSelect[key].every(item => selectedKeys.includes(item));
      if (allChecked) {
        signalChecked.push(key)
      } else if (allPortSelect[key].some(item => selectedKeys.includes(item))) {
        signalHalfChecked.push(key)
      }
    }

    return { checked: [...checked, ...signalChecked], halfChecked: [...halfChecked, ...signalHalfChecked] }
  }

  changePorts = (groups) => {
    const { portSelect } = this.state;
    for (let item of groups) {
      portSelect[item.rowName] = [...(item.values || [])];
    }
    this.setState({ portSelect }, () => { this.setResultOpera({ portSelect }); this.getCurves() })
  }

  clearPort = (currentId, rowName) => {
    this.setState({ portSelect: {} }, () => {
      this.changePort([currentId], rowName)
    })
  }

  getCurves = () => {
    const { portSelect, compInfo } = this.state;
    const keyMap = Object.keys(portSelect);
    let selectedComponentKeys = [];
    for (let key of keyMap) {
      const select = portSelect[key];
      select.forEach(s => {
        const info = compInfo.find(comp => comp.portSelectId === s);
        if (info) {
          selectedComponentKeys.push(info.curveIndex);
        }
      })
    }
    const curves = this.waveform.getCurves();
    curves.forEach((curve, i) => {
      curve.visible = selectedComponentKeys.includes(i);
    });
    this.waveform.updataRawCurvePlot();
  }

  _rowNameClick = (displayMode, value) => {
    let _dataList = { ...this.state.dataList };
    if (_dataList[displayMode]) {
      let _show = [..._dataList[displayMode].show];
      if (_show.includes(value)) {
        _show = _show.filter(item => item !== value);
      } else {
        _show.push(value);
      }
      _dataList[displayMode].show = _show;
      this.setState({
        dataList: _dataList
      });
    }
  };

  _updateSweepReCalc = (sweepReCalc) => {
    this.setState({
      allSweepReCalc: JSON.parse(JSON.stringify(sweepReCalc || []))
    })
    this.props._updateSweepReCalc([...(sweepReCalc || []).map(item => item.id)]);
  }

  showSweepTime = (name, expand) => {
    const { sweepTimeShowList } = this.state;
    let _sweepTimeShowList = [...sweepTimeShowList];
    if (expand) {
      _sweepTimeShowList.push(name)
    } else {
      _sweepTimeShowList = _sweepTimeShowList.filter(item => item !== name);
    }
    this.setState({
      sweepTimeShowList: _sweepTimeShowList
    })
  }

  updateGPIOSpecInPPROCConfig = (postProcessConfig, sweepName) => {
    const { compInfo } = this.state;

    let _compInfo = [...compInfo];

    for (let info of _compInfo) {
      if (info.experiment === sweepName) {
        info.postProcessConfig = JSON.parse(JSON.stringify(postProcessConfig || info.postProcessConfig || {}));
      }
    }

    this.setState({
      compInfo: _compInfo
    })
  }

  updateExpandKeys = (keys) => {
    this.setState({
      expandedKeys: keys
    })
  }

  render() {
    const { loading, compInfo, displayMode, currentSignals, resultList, dataList, portSelect, allDesigns, allPortSelect, isPostProcess, sweepTimeShowList, resultOpera, isNewPPROCObj, expandedKeys } = this.state;
    return <WaveForm
      {...this.props}
      {...this.resultListAction}
      compRef={(ref) => { this.childComp = ref }}
      onRef={this.onRef}
      loading={loading}
      compInfo={compInfo}
      displayMode={displayMode}
      currentInterfaceInfo={currentSignals}
      waveform={this.waveform}
      svgRef={this.svgRef}
      sweepTimeShowList={sweepTimeShowList}
      updateState={this.updateState}
      waveformSetting={this.waveformSetting}
      displayModeChange={this.displayModeChange}
      verificationSubId={this.props.sweepId}
      resultList={resultList}
      dataList={dataList}
      portSelect={portSelect}
      allDesigns={allDesigns}
      sweep={true}
      allPortSelect={allPortSelect}
      isPostProcess={isPostProcess}
      clearPort={this.clearPort}
      recalcMeasure={this.props.recalcMeasure}
      _updateSweepReCalc={this._updateSweepReCalc}
      _updateProgress={this.props._updateProgress}
      showSweepTime={this.showSweepTime}
      resultOpera={resultOpera}
      updateGPIOSpecInPPROCConfig={this.updateGPIOSpecInPPROCConfig}
      isNewPPROCObj={isNewPPROCObj}
      expandedKeys={expandedKeys}
      updateExpandKeys={this.updateExpandKeys}
      getSweepChecked={this.getSweepChecked}
      changeTreeCheckedKeys={this.changeTreeCheckedKeys}
      getTreeCheckedKeys={this.getTreeCheckedKeys}
    />
  }

  setResultOpera = (newSetting) => {
    const { expVerificationId } = this.props;
    const { resultOpera } = this.state;
    if (newSetting.portSelect && newSetting.portSelect.undefined) {
      delete newSetting.portSelect.undefined;
    }

    this.setState({
      resultOpera: { ...resultOpera, ...newSetting }
    }, () => {
      resultOperation.setOperationByKey(expVerificationId, WAVEFORM, { ...resultOpera, ...newSetting })
    })
  }

  resultListAction = {
    colorChange: this.colorChange,
    changePort: this.changePort,
    changeSinglePort: this.changeSinglePort,
    _rowNameClick: this._rowNameClick,
    setResultOpera: this.setResultOpera,
    changePorts: this.changePorts,
    changeSelectAll: this.changeSelectAll
  }
}

const mapState = (state) => {
  const { project, sweep: { experimentInfo }, simulationReducer: { singleProgress }, resultReducer: { sweepReCalc }, library: { libraryTreeInfo } } = state.SierraReducer;
  const { currentProjectId } = project;
  const { id = "", resultList = [] } = experimentInfo;
  const expVerificationId = resultList.length ? resultList[0].verificationId : "";
  return {
    currentProjectId,
    sweepId: id,
    singleProgress,
    sweepReCalc,
    expVerificationId,
    libraryTreeInfo
  }
}

const mapDispatch = (dispatch) => ({
  recalcMeasure(configList, isSweep) {
    dispatch(recalcMeasure(configList, isSweep))
  },
  _updateSweepReCalc(sweepReCalc) {
    dispatch(updateSweepReCalc(sweepReCalc))
  },
  _updateProgress({ verificationId, progress }) {
    dispatch(updateProgress({ verificationId, progress }))
  },
  _updateLibraryTree(type) {
    dispatch(updateLibraryTree(type))
  }
})

export default connect(mapState, mapDispatch)(WaveformSweep);